"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var connected_react_router_1 = require("connected-react-router");
var reducers_1 = __importDefault(require("./oidc/reducers"));
var reducers_2 = __importDefault(require("./tenant/reducers"));
var reducers_3 = __importDefault(require("./breadcrumb/reducers"));
exports.default = (function (history, reducers) {
    return redux_1.combineReducers(__assign(__assign({}, reducers), { router: connected_react_router_1.connectRouter(history), oidc: reducers_1.default,
        tenant: reducers_2.default,
        breadcrumb: reducers_3.default }));
});
//# sourceMappingURL=reducers.js.map